export interface SlideLike {
  slideName?: string;
}

/**
 * Replaces legacy default names like "Page N" / "Slide N" with localized labels.
 * Mutates the provided slides array in-place.
 */
export const localizeLegacyNames = (
  slides: SlideLike[] = [],
  t: (key: string, params?: Record<string, unknown>) => string,
  match: RegExp,
  labelKey: string
): void => {
  try {
    slides.forEach((slide, index) => {
      const name = (slide?.slideName || "").toString();
      if (match.test(name)) {
        slide.slideName = t(labelKey, { n: index + 1 });
      }
    });
  } catch (error) {
    console.error("localizeLegacyNames: failed to localize legacy names", error);
  }
};
